











import { Vue, Component } from "vue-property-decorator";
import DocTemplateFormV2 from "@/components/doc-tempates/DocTemplateFormV2.vue";
import { TemplateFileCreate as ITemplateFileCreate } from "@/api-v2/document-generator/models/template-file-create";
import { documentGeneratorApi } from "@/getinfo-api";

@Component({
  components: { DocTemplateFormV2 }
})
export default class DocTemplateNew extends Vue {
  isLoading: boolean = false;

  redirect() {
    this.$router.push({
      name: "docTemplates"
    });
  }

  async saveTemplate(template: ITemplateFileCreate) {
    try {
      this.isLoading = true;
      await documentGeneratorApi.TemplateFiles.createTemplateFile(template);
      await this.$store.dispatch("successToast", { message: "Успешно создан" });
      await this.redirect();
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }
}
